import { APPLY_STATUS } from '@/data/default'

const campaignListInfluence = [
  {
    id: 'GoldVermeilRings',
    companyName: 'Rings Company',
    productName: 'Gold Vermeil Rings',
    productValue: 350,
    productCategory: 'accessories',
    productTag: ['ring', 'gift', 'gold'],
    productDescription: "Gold vermeil rings are an affordable and luxurious option for jewelry lovers. With a thick layer of 18k gold over sterling silver, these rings have the durability and beauty of gold without the high price tag. The warm tones of the gold complement any outfit and can be worn for any occasion, from casual to formal. The timeless design of these rings ensures they will remain a cherished addition to your jewelry collection for years to come.",
    maxTotalSales: 5000,
    influencerMaxSales: 1000,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: true,
    imageName: 'rings',
    totalRevenue: 77000,
    totalSales: 220,
    totalCommission: 6846,
    influencerNum: 4,
    activeDate: '7/11/2023 - 9/22/2023',
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'Sarah Johnson',
        level: 21,
        avatarImage: 'influencer-0',
        currentTier: 3,
        soldNum: 120,
        revenue: 42000,
        commission: 3969,
      },
      {
        rank: 2,
        name: 'Jessica Ramirez',
        level: 13,
        avatarImage: 'influencer-1',
        currentTier: 2,
        soldNum: 60,
        revenue: 21000,
        commission: 1757,
      },
      {
        rank: 3,
        name: 'Anthony lee',
        level: 7,
        avatarImage: 'influencer-2',
        currentTier: 1,
        soldNum: 30,
        revenue: 10500,
        commission: 840,
      },
      {
        rank: 4,
        name: 'Michael Davis',
        level: 2,
        avatarImage: 'influencer-5',
        currentTier: 1,
        soldNum: 10,
        revenue: 3500,
        commission: 280,
      },
    ],
    status: APPLY_STATUS.Pending,
    currentStep: 0,
  },
  {
    id: 'MinimalisticWatch',
    companyName: 'Watch Company',
    productName: 'Minimalistic Watch',
    productValue: 450,
    productCategory: 'accessories',
    productTag: ['watch', 'gift', 'time'],
    productDescription: "The Minimalistic Watch is a stylish timepiece that embodies simplicity and elegance. Its sleek and understated design features a clean, uncluttered face with slim hour markers and slim hands, housed in a slim and lightweight case. With its versatile style, it's the perfect accessory for any occasion.",
    maxTotalSales: 2000,
    influencerMaxSales: 500,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: false,
    imageName: 'watch',
    totalRevenue: 20250,
    totalSales: 45,
    totalCommission: 1620,
    influencerNum: 1,
    activeDate: '7/11/2023 - 9/22/2023',
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'Samantha Taylor',
        level: 21,
        avatarImage: 'influencer-3',
        currentTier: 1,
        soldNum: 45,
        revenue: 20250,
        commission: 1620,
      },
    ],
    status: APPLY_STATUS.Pending,
    currentStep: 0,
  },
  {
    id: 'BabyBlueShoulderBag',
    companyName: 'Bag Company',
    productName: 'Baby Blue Shoulder Bag',
    productValue: 500,
    productCategory: 'accessories',
    productTag: ['bag', 'gift', 'blue'],
    productDescription: "The Baby Blue Shoulder Bag is a stylish and practical accessory for any outfit. With a soft blue exterior and a durable shoulder strap, this bag features multiple pockets for easy organization and storage. Perfect for carrying essentials like keys, phone, wallet, and more.",
    maxTotalSales: 5000,
    influencerMaxSales: 1000,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: true,
    imageName: 'bag',
    totalRevenue: 0,
    totalSales: 0,
    totalCommission: 0,
    influencerNum: 0,
    activeDate: '7/11/2023 - 9/22/2023',
    status: APPLY_STATUS.Pending,
    currentStep: 0,
  },
  {
    id: 'sunglasses',
    companyName: 'Sun Glasses Company',
    productName: 'Sun Glasses',
    productValue: 250,
    productCategory: 'accessories',
    productTag: ['glass', 'gift', 'sun'],
    productDescription: "These stylish sunglasses offer both fashion and function. With their sleek design and UV-protective lenses, they're perfect for any outdoor activity. The lightweight frame and comfortable fit make them easy to wear all day. Whether you're at the beach or just running errands, these sunglasses are a must-have accessory.",
    maxTotalSales: 3000,
    influencerMaxSales: 600,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: false,
    imageName: 'sunglasses',
    totalRevenue: 30000,
    totalSales: 120,
    totalCommission: 2555,
    influencerNum: 2,
    activeDate: '7/11/2023 - 9/22/2023',
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'David Kim',
        level: 20,
        avatarImage: 'influencer-6',
        currentTier: 2,
        soldNum: 80,
        revenue: 20000,
        commission: 1755,
      },
      {
        rank: 2,
        name: 'Rachel Chen',
        level: 6,
        avatarImage: 'influencer-4',
        currentTier: 1,
        soldNum: 40,
        revenue: 10000,
        commission: 800,
      },
    ],
    status: APPLY_STATUS.Applied,
    currentStep: 0,
  },
  {
    id: 'CedarwoodSoyCandle',
    companyName: 'Candle Company',
    productName: 'Cedarwood Soy Candle',
    productValue: 60,
    productCategory: 'beautypersonal',
    productTag: ['candle', 'gift', 'soy'],
    productDescription: "The Cedarwood Soy Candle is a natural, eco-friendly, and sustainable candle made with pure soy wax and scented with the warm, woody aroma of cedarwood. Its clean-burning wick and long-lasting fragrance create a cozy ambiance in any room.",
    maxTotalSales: 3000,
    influencerMaxSales: 600,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: false,
    imageName: 'candle',
    totalRevenue: 21300,
    totalSales: 355,
    influencerNum: 3,
    activeDate: '7/11/2023 - 9/22/2023',
    mineProgressDetail: {
      rank: 1,
      name: 'Sarah Johnson',
      level: 21,
      avatarImage: 'influencer-0',
      currentTier: 3,
      soldNum: 155,
      revenue: 9300,
      commission: 932.4,
      exp: 93,
    },
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'Sarah Johnson',
        level: 21,
        avatarImage: 'influencer-0',
        currentTier: 3,
        soldNum: 155,
        revenue: 9300,
        commission: 932.4,
        exp: 93,
      },
      {
        rank: 2,
        name: 'Jessica Ramirez',
        level: 13,
        avatarImage: 'influencer-1',
        currentTier: 3,
        soldNum: 100,
        revenue: 6000,
        commission: 536.4,
        exp: 53,
      },
      {
        rank: 2,
        name: 'Anthony lee',
        level: 7,
        avatarImage: 'influencer-2',
        currentTier: 3,
        soldNum: 100,
        revenue: 6000,
        commission: 536.4,
        exp: 53,
      },
    ],
    status: APPLY_STATUS.Matched,
    currentStep: 4,
  },
  {
    id: 'EaudePerfume',
    companyName: 'Perfume Company',
    productName: 'Eau de Perfume',
    productValue: 100,
    productCategory: 'beautypersonal',
    productTag: ['perfume', 'gift', 'cologne'],
    productDescription: "Introducing our exquisite Eau de Parfum, a captivating fragrance that blends notes of jasmine, vanilla, and sandalwood to create a luxurious scent. With its long-lasting and alluring aroma, this perfume is perfect for any occasion. Indulge in a scent that truly represents your unique style and personality.",
    maxTotalSales: 5000,
    influencerMaxSales: 1000,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: false,
    imageName: 'perfume',
    totalRevenue: 9800,
    totalSales: 98,
    influencerNum: 1,
    activeDate: '7/11/2023 - 9/22/2023',
    mineProgressDetail: {
      rank: 1,
      name: 'Sarah Johnson',
      level: 21,
      avatarImage: 'influencer-0',
      currentTier: 2,
      soldNum: 98,
      revenue: 9800,
      commission: 882,
      exp: 82,
    },
    influencerProgressDetail: [
      {
        rank: 1,
        name: 'Sarah Johnson',
        level: 21,
        avatarImage: 'influencer-0',
        currentTier: 2,
        soldNum: 98,
        revenue: 9800,
        commission: 882,
        exp: 82,
      },
    ],
    status: APPLY_STATUS.Matched,
    currentStep: 4,
  },
  {
    id: 'LeatherWatch',
    companyName: 'Watch Company',
    productName: 'Leather Watch',
    productValue: 800,
    productCategory: 'accessories',
    productTag: ['watch', 'gift', 'leather'],
    productDescription: "The Leather Watch is an elegant timepiece crafted with precision and style. It features a genuine leather strap that exudes sophistication, complemented by a sleek stainless steel case. With its reliable movement and timeless design, it is the perfect accessory for any occasion.",
    maxTotalSales: 5000,
    influencerMaxSales: 1000,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: true,
    imageName: 'black-watch',
    totalRevenue: 0,
    totalSales: 0,
    totalCommission: 0,
    influencerNum: 0,
    activeDate: '6/11/2023 - 7/22/2023',
    status: APPLY_STATUS.Default,
    currentStep: 0,
  },
  {
    id: 'BeigeSneakers',
    companyName: 'Sneakers Company',
    productName: 'Beige Sneakers',
    productValue: 500,
    productCategory: 'shoes',
    productTag: ['sneaker', 'gift', 'white'],
    productDescription: "Beige Sneakers are stylish and versatile footwear that combines comfort and fashion. Made with high-quality materials, they offer a neutral color palette that effortlessly complements various outfits. These sneakers are perfect for casual or dressy occasions, providing a trendy and sophisticated look.",
    maxTotalSales: 5000,
    influencerMaxSales: 1000,
    missionGuideline: "For every product sold, you will earn a 8% commission. As you reach the target sales in each stage, the commission percentage will increase. There are no restrictions on any sponsorship methods. Good luck to everyone!",
    tierList: [
      {
        tier: 1,
        goalNum: null,
        commission: 8,
      },
      {
        tier: 2,
        goalNum: 50,
        commission: 10,
      },
      {
        tier: 3,
        goalNum: 100,
        commission: 12,
      },
    ],
    influencerRequirement: {
      gender: ['all'],
      age: ['all'],
      level: ['all'],
      category: ['beauty', 'fashion', 'home'],
      platform: ['all'],
    },
    isLiked: true,
    imageName: 'sneakers',
    totalRevenue: 0,
    totalSales: 0,
    totalCommission: 0,
    influencerNum: 0,
    activeDate: '5/21/2023 - 8/10/2023',
    status: APPLY_STATUS.Default,
    currentStep: 0,
  },
]

const profileInfo = {
  id: 'sarahjohnson',
  name: 'Sarah Johnson',
  avatarImage: 'influencer-0',
  level: 21,
  levelRange: 'D',
  exp: 23,
  description: "Hey there! My name is Sarah Johnson, and I'm a lifestyle influencer. I'm passionate about sharing my experiences with wellness, food, and travel. I love dis-covering new trends, exploring new places, and trying out new things. Join me on my journey to live life to the fullest, one day at a time.",
  categoryList: [
    {
      name: 'Beauty and skincare',
      image: 'Beauty',
      exp: 40,
    },
    {
      name: 'Health and wellness',
      image: 'Health',
      exp: 46,
    },
    {
      name: 'Fashion and apparel',
      image: 'Fashion',
      exp: 90,
    }
  ],
  socialMedia: [
    {
      name: 'Tiktok',
      fansNum: 533,
      image: 'tiktok',
      icon: ['fab', 'tiktok']
    },
    {
      name: 'Youtube',
      fansNum: 85,
      image: 'youtube',
      icon: ['fab', 'youtube']
    },
    {
      name: 'Instagram',
      fansNum: 300,
      image: 'instagram',
      icon: ['fab', 'instagram']
    },
    {
      name: 'Facebook',
      fansNum: 106,
      image: 'facebook',
      icon: ['fab', 'square-facebook']
    },
  ],
}

export {
  campaignListInfluence,
  profileInfo,
}